var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label-form"},[(_vm.required)?_c('span',{staticClass:"label-form-required"},[_vm._v("*")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }